import React from 'react';
import { GOOGLE_AUTH_URL } from '../../Constants';
import googleLogo from '../../assets/images/google-logo.png';



function SocialSignup() {
    return (
        <div className="social-login">
            <a className="link-primary" href={GOOGLE_AUTH_URL}>
            <div className="text-center fw-semibold fs-6 google-login-btn">
                <img src={googleLogo} alt="Google" style={{width:"22px"}}/> Sign up with Google
                </div>
                </a>
        </div>

    );
}

export default SocialSignup;
